import { render, staticRenderFns } from "./LuogoRitiro.vue?vue&type=template&id=17d48e9a"
import script from "./LuogoRitiro.vue?vue&type=script&lang=ts"
export * from "./LuogoRitiro.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports